import {
  getSections,
  getSectionsByZoneId,
  createSection,
  updateSection,
  deleteSection,
} from "../../../api/sections/sectionRequest";
import { useEntityManagement } from "../../../hooks/useEntityManagement";

export const useSectionManagement = (zoneId, form) => {
  const sectionManagement = useEntityManagement(form, {
    entityName: "Zone",
    api: {
      getEntities: () => getSectionsByZoneId(zoneId),
      createEntity: (value) => createSection({ ...value, zone_id: zoneId }),
      updateEntity: updateSection,
      deleteEntity: deleteSection,
    },
  });

  return {
    ...sectionManagement,
  };
};
